import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcClose16Icon, IcReplyIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { FAB, IconView } from '@gem/ui-kit';

import { MiniatureMessage } from 'APP/main/ChatView/components/MiniatureMessage/MiniatureMessage';

import { useRepliedMessagePresenter } from './RepliedMessage.presenter';
import styles from './RepliedMessage.styles.m.css';

interface IQuotedMessageProps {
  className?: string;
}

export const RepliedMessage: FC<IQuotedMessageProps> = observer(({ className }) => {
  const presenter = useRepliedMessagePresenter();

  if (!presenter.isReplyMode) {
    return null;
  }

  return (
    <div className={className}>
      <AddKeyPressHandler onEsc={presenter.endReply} />
      <IconView
        Icon={IcReplyIcon}
        className={styles.icon}
      />
      <div className={styles.miniature}>
        <MiniatureMessage
          titleClassName={styles.miniatureTitle}
          textClassName={styles.miniatureText}
          iconClassName={styles.miniatureIcon}
          message={presenter.message}
          title={<p className={styles.title}>{presenter.title}</p>}
        />
      </div>
      <FAB
        Icon={IcClose16Icon}
        size="10"
        iconSize="0"
        theme="12"
        onClick={presenter.endReply}
        className={styles.remove}
      />
    </div>
  );
});
